import secureLocalStorage from "react-secure-storage";
import {
  extendDataItem, mapTree, TreeList, TreeListSelectionCell
} from "@progress/kendo-react-treelist";
import React, { Component } from "react";
import { toastr } from "react-redux-toastr";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import Images from "../../Assets/Images";
const subItemsField = "children";
const expandField = "expanded";
const selectField = "selected";
const options1 = [
  { value: "Project Admin", label: "Project Admin" },
  { value: "Super User", label: "Super User" },
  { value: "Standard User", label: "Standard User" },
  { value: "View Only", label: "View Only" },
  { value: "None", label: "None" }
];
const options2 = [
  { value: "Super User", label: "Super User" },
  { value: "Standard User", label: "Standard User" },
  { value: "View Only", label: "View Only" },
  { value: "None", label: "None" }
];
const options3 = [
  { value: "View Only", label: "View Only" },
  { value: "None", label: "None" }
];
export default class WorkStreamWithRoles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      expanded: [],
      selected: [],
      isLogged: true,
      workstreamRole: [],
      workstreamRoleForTask: [],
    };
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    if (this.props.orgUnitData && this.state.isLogged) {
      this.setState(
        {
          ...this.state,
          data: this.props.orgUnitData,
          isLogged: false,
          selected: [],
        },
        () => console.log("-")
      );

      if (this.props.selectedOrgUnit) {
        this.setState({
          ...this.state,
          data: this.props.orgUnitData,
          isLogged: false,
          selected: this.props.selectedOrgUnit,
        });
      }
      if (this.props.editModeWorkstreamRoles) {
        this.populateWorkstream(this.props.editModeWorkstreamRoles);
      }
    }
  }

  refreshRole = async (data) => {
    await this.populateWorkstream(data);
  };
  populateWorkstream = async (data) => {
    let arr = [];
    await Promise.all(
      data.map((item) => {
        let riskRoleObj = {
          label: item.role,
          value: item.role,
        };
        let taskRoleObj = {
          label: item.taskRole,
          value: item.taskRole,
        };
        arr.push({
          id: item.workstreamId,
          role: item.role,
          taskRole: item.taskRole
        });
        this.populateRoleInChildren(
          this.props.orgUnitData,
          item.workstreamId,
          riskRoleObj,
          taskRoleObj
        );
      })
    );

    let riskRoleData = [...this.state.workstreamRole, ...arr];
    let taskRoleData = [...this.state.workstreamRoleForTask, ...arr];
    await this.passToParentForRisk(riskRoleData);
    await this.passToParentForTask(taskRoleData);
    this.setState({ ...this.state, workstreamRole: riskRoleData, workstreamRoleForTask: taskRoleData });
    this.expandAll();
  };

  populateRoleInChildren = (childrenData, selectedID, riskRoleObj,taskRoleObj) => {
    if (childrenData && childrenData.length > 0) {
      childrenData.forEach(async (element, index) => {
        if (element.unitId === selectedID) {
          element.role = riskRoleObj;
          element.taskRole = taskRoleObj;
        } else {
          if (element.children) {
            await this.populateRoleInChildren(element.children, selectedID, riskRoleObj,taskRoleObj);
          }
        }
      });
    }
  };

  expandAll = () => {
    let arr = [];
    mapTree(this.state.data, subItemsField, (item) => {
      arr.push(item.unitId);
      return item;
    });
    this.setState({ ...this.state, expanded: arr });
  };

  refreshData(data) {
    this.setState(
      {
        ...this.state,
        selected: data,
      },
      () => {
        //callback
        console.log("selected", this.state.selected); // myname
      }
    );
  }
  handleRowClick = (e) => {
    const selected = e.dataItem.selected
      ? this.state.selected.filter((x) => x !== e.dataItem.unitId)
      : [...this.state.selected, e.dataItem.unitId];
    this.setState({ selected });
  };

  onExpandChange = (e) => {
    var expanded = e.value
      ? this.state.expanded.filter((unitId) => unitId !== e.dataItem.unitId)
      : [...this.state.expanded, e.dataItem.unitId];
    this.setState({ ...this.state, expanded: expanded });
  };

  updateFields = (dataArr) => {
    const { expanded, selected } = this.state;
    let wsData = mapTree(dataArr, subItemsField, (item) =>
      extendDataItem(item, subItemsField, {
        expanded: expanded.includes(item.unitId),
        selected: selected.includes(item.unitId),
        role: this.getDefaultRole(item,selected),
        taskRole: this.getDefaultTaskRole(item,selected),
      })
    );
    console.log("wsData",wsData);
    return wsData;
  };

  getDefaultRole = (item,selected)=>{
    let exrole = this.state.workstreamRole.find((wr)=>wr.id===item.unitId);
    let defaultValue = null;
    if(exrole){
      defaultValue=options1.find((op)=>op.value===exrole.role);
    }
    let res = (!item.role || typeof item.role ==="string" )&& selected.includes(item.unitId) ? { value: "None", label: "None" } : defaultValue;
    return res;
  }
  getDefaultTaskRole = (item,selected)=>{
    let exrole = this.state.workstreamRoleForTask.find((wr)=>wr.id===item.unitId);
    let defaultValue = null;
    if(exrole){
      defaultValue=options1.find((op)=>op.value===exrole.taskRole);
    }
    let res = (!item.taskRole || typeof item.taskRole ==="string" )&& selected.includes(item.unitId) ? { value: "None", label: "None" } : defaultValue;
    return res;
  }
  onSelectionChange = (event) => {
    this.changeSelection(event.dataItem);
  };

  childrenSelection = (childrenData) => {
    let childrenChecked = [];
    if (childrenData && childrenData.length > 0) {
      childrenData.forEach((element, index) => {
        childrenChecked.push(element.unitId);
        if (element.children) {
          let childList = this.childrenSelection(element.children);
          childrenChecked = [...childrenChecked, ...childList];
        }
      });
    }
    return childrenChecked;
  };

  changeSelection = (dataItem) => {
    let selected = [];
    if (dataItem.selected === false) {
      selected.push(dataItem.unitId);
      if (this.state.selected.length > 0) {
        this.state.selected.map((element) => {
          selected.push(element);
        });
      }
    } else if (dataItem.selected === true) {
      let unSelectedItem = [];

      unSelectedItem.push(dataItem.unitId);
      selected = this.state.selected.filter(
        (val) => !unSelectedItem.includes(val)
      );
    }
    this.setState({ ...this.state, selected }, () => {});
    this.passToParentWithSelectedIdForRisk(this.state.workstreamRole, selected);
    this.passToParentWithSelectedIdForTask(this.state.workstreamRoleForTask, selected);
    if (selected.length === 0) {
      this.props.getEmptyRiskList(selected);
    } else {
      this.props.getRiskList(selected);
    }
  };
  onRowClick = (event) => {
    if (event.dataItem.isVisible) {
      this.changeSelection(event.dataItem);
    } else {
      toastr.error("You can't select this workstream due to permissions");
    }
  };

  onHeaderSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const selected = [];
    if (checked) {
      mapTree(this.state.data, subItemsField, (item) => {
        selected.push(item.unitId);
        return item;
      });
    }

    this.setState({ selected });

    if (selected.length === 0) {
      this.props.getEmptyRiskList(selected);
    } else {
      this.props.getRiskList(selected);
    }
  };

  headerSelectionValue = () => {
    let allSelected = true;
    const selected = this.state.selected;
    mapTree(this.state.data, subItemsField, (item) => {
      allSelected = allSelected && selected.includes(item.unitId);
      return item;
    });

    return allSelected;
  };

  handleDropDownChangeForRisk = async (selectedValue, props) => {
    // Prevent selecting the "Select Role" option
    if (selectedValue.value === null) {
      return;
    }
    
    let arr = [];
    // Create a proper object format for the dropdown value
    const e = {
      value: selectedValue.value,
      label: selectedValue.label
    };
    
    //update role for each workstream
    this.state.data.map(async (item) => {
      if (item.unitId === props.dataItem.unitId) {
        item.role = e;
      } else {
        if (item.children) {
          await this.updateRoleInChildrenForRisk(
            item.children,
            props.dataItem.unitId,
            e
          );
        }
      }
    });

    mapTree(this.state.data, subItemsField, (item) => {
      if (item.unitId === props.dataItem.unitId) {
        arr.push({
          id: props.dataItem.unitId,
          role: e.value,
        });
      }
      return item;
    });
    let removeOldObj= this.state.workstreamRole.filter((item)=>item.id !== props.dataItem.unitId);
    let roleData = [...removeOldObj, ...arr];
    this.setState({
      ...this.state,
      workstreamRole: roleData,
    });
    this.passToParentForRisk(roleData);
  };

  handleDropDownChangeForTask = async (selectedValue, props) => {
    // Prevent selecting the "Select Role" option
    if (selectedValue.value === null) {
      return;
    }
    
    let arr = [];
    // Create a proper object format for the dropdown value
    const e = {
      value: selectedValue.value,
      label: selectedValue.label
    };
    
    //update role for each workstream
    this.state.data.map(async (item) => {
      if (item.unitId === props.dataItem.unitId) {
        item.taskRole = e;
      } else {
        if (item.children) {
          await this.updateRoleInChildrenForTask(
            item.children,
            props.dataItem.unitId,
            e
          );
        }
      }
    });

    mapTree(this.state.data, subItemsField, (item) => {
      if (item.unitId === props.dataItem.unitId) {
        arr.push({
          id: props.dataItem.unitId,
          taskRole: e.value,
        });
      }
      return item;
    });

    let removeOldObj= this.state.workstreamRoleForTask.filter((item)=>item.id !== props.dataItem.unitId);
    let roleDataForTask = [...removeOldObj, ...arr];
    this.setState({
      ...this.state,
      workstreamRoleForTask: roleDataForTask,
    });
    this.passToParentForTask(roleDataForTask);
  };
  updateRoleInChildrenForRisk = (childrenData, selectedID, e) => {
    let arr = [];
    if (childrenData && childrenData.length > 0) {
      childrenData.forEach(async (element, index) => {
        if (element.unitId === selectedID) {
          element.role = e;
          arr.push({
            id: selectedID,
            role: e.value,
          });
        } else {
          if (element.children) {
            await this.updateRoleInChildrenForRisk(
              element.children,
              selectedID,
              e
            );
          }
        }
      });
    }
  };

  updateRoleInChildrenForTask = (childrenData, selectedID, e) => {
    let arr = [];
    if (childrenData && childrenData.length > 0) {
      childrenData.forEach(async (element, index) => {
        if (element.unitId === selectedID) {
          element.taskRole = e;
          arr.push({
            id: selectedID,
            taskRole: e.value,
          });
        } else {
          if (element.children) {
            await this.updateRoleInChildrenForTask(
              element.children,
              selectedID,
              e
            );
          }
        }
      });
    }
  };

  passToParentForRisk = (roleData) => {
    let val = roleData
      .slice()
      .reverse()
      .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
      .reverse();
    let res = [];
    val.map((item) => {
      if (this.state.selected && this.state.selected.includes(item.id)) {
        res.push(item);
      }
    });
    this.props.saveRoleWithOrgIdForRisk(res);
  };

  passToParentForTask = (roleData) => {
    let val = roleData
      .slice()
      .reverse()
      .filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i)
      .reverse();
    let resultTask = [];
    val.map((item) => {
      if (this.state.selected && this.state.selected.includes(item.id)) {
        resultTask.push(item);
      }
    });
    this.props.saveRoleWithOrgIdForTask(resultTask);
  };

  passToParentWithSelectedIdForRisk = (workstreamRole, selected) => {
    let res = [];
    workstreamRole.map((item) => {
      if (selected.includes(item.id)) {
        res.push(item);
      }
    });
    this.passToParentForRisk(res);
  };

  passToParentWithSelectedIdForTask = (workstreamRole, selected) => {
    let res = [];
    workstreamRole.map((item) => {
      if (selected.includes(item.id)) {
        res.push(item);
      }
    });
    this.passToParentForTask(res);
  };
  cellRender = (cell, props) => {
    if (props.expandable) {
      return (
        <cell.type
          {...cell.props}
          className={props.dataItem.isVisible ? `` : "isVisibleWS"}
        />
      );
    }
    return cell;
  };
  render() {
    const wsData = this.props.orgUnitData ? this.props.orgUnitData : [];
    const isTasksModuleEnabled=secureLocalStorage.getItem("isTasksModuleEnabled");
    const userId = secureLocalStorage.getItem("userId")
    if( isTasksModuleEnabled === true){
      return (
        <TreeList
          style={{ maxHeight: "400px", overflow: "auto" }}
          data={this.updateFields(wsData)}
          selectedField={selectField}
          onSelectionChange={this.onSelectionChange}
          onHeaderSelectionChange={this.onHeaderSelectionChange}
          expandField={expandField}
          subItemsField={subItemsField}
          onExpandChange={this.onExpandChange}
          reorderable={true}
          resizable={true}
          columns={[
            {
              field: "selected",
              width: "5%",
              title: "-",
              headerSelectionValue: this.headerSelectionValue(),
              className: "k-text-center",
              headerClassName: "k-text-center admin-grid-width",
              cell: (props) =>
                props.dataItem.isVisible ? (
                  <TreeListSelectionCell {...props} />
                ) : (
                  <td className="k-text-center">
                    <span className="noaccess k-text-center">
                      <img
                        className="noaccessImg"
                        title="No access"
                        src={Images.NOTACCESS}
                        width="12"
                        alt=""
                      />
                    </span>
                  </td>
                ),
            },
            {
              field: "name",
              title: "Workstream",
              expandable: true,
              width: "55%",
              headerClassName: "k-text-center",
            },
            
            {
              field: "role",
              title: "Risk Register Role",
              width: "20%",
              className: "k-text-center",
              headerClassName: "k-text-center",
              cell: (props) => (
                <td className={`selectRoleDropdownContainer ${props.dataItem.selected ? 'selected-row-cell' : ''}`}>
                  <div className="selectRoleDropdown" style={{ width: "100%" }}>
                    <DropDownList
                      data={this.props.isTenent ? options1 : props.dataItem.isRiskAdmin === false ? options3 : options2}
                      textField="label"
                      dataItemKey="value"
                      value={props.dataItem.selected ? (props.dataItem.role || { label: "Select Role", value: null }) : undefined}
                      disabled={!props.dataItem.selected || !props.dataItem.isVisible}
                      onChange={(e) => this.handleDropDownChangeForRisk(e.target.value, props)}
                      placeholder="Select Role"
                      defaultItem={{ label: "Select Role", value: null }}
                      style={{ width: "100%" }}
                    />
                  </div>
                </td>
              ),
            },
            {
              field: "role",
              title: "Task Register Role",
              width: "20%",
              className: "k-text-center",
              headerClassName: "k-text-center",
              cell: (props) => (
                <td className={`selectRoleDropdownContainer ${props.dataItem.selected ? 'selected-row-cell' : ''}`}>
                  <div className="selectRoleDropdown" style={{ width: "100%" }}>
                    <DropDownList
                      data={this.props.isTenent ? options1 : props.dataItem.isTaskAdmin === false ? options3 : options2}
                      textField="label"
                      dataItemKey="value"
                      value={props.dataItem.selected ? (props.dataItem.taskRole || { label: "Select Role", value: null }) : undefined}
                      disabled={!props.dataItem.selected || !props.dataItem.isVisible}
                      onChange={(e) => this.handleDropDownChangeForTask(e.target.value, props)}
                      placeholder="Select Role"
                      defaultItem={{ label: "Select Role", value: null }}
                      style={{ width: "100%" }}
                    />
                  </div>
                </td>
              ),
            }
          ]}
        />
      );
    }else{
    return (
      <TreeList
        style={{ maxHeight: "400px", overflow: "auto" }}
        data={this.updateFields(wsData)}
        selectedField={selectField}
        onSelectionChange={this.onSelectionChange}
        onHeaderSelectionChange={this.onHeaderSelectionChange}
        expandField={expandField}
        subItemsField={subItemsField}
        onExpandChange={this.onExpandChange}
        reorderable={true}
        resizable={true}
        columns={[
          {
            field: "selected",
            width: "5%",
            title: "-",
            headerSelectionValue: this.headerSelectionValue(),
            className: "k-text-center",
            headerClassName: "k-text-center admin-grid-width",
            cell: (props) =>
              props.dataItem.isVisible ? (
                <TreeListSelectionCell {...props} />
              ) : (
                <span className="noaccess k-text-center">
                  <img
                    className="noaccessImg"
                    title="No access"
                    src={Images.NOTACCESS}
                    width="12"
                    alt=""
                  />
                </span>
              ),
          },
          {
            field: "name",
            title: "Workstream",
            expandable: true,
            width: "55%",
            headerClassName: "k-text-center",
          },
          
          {
            field: "role",
            title: "Risk Register Role",
            width: "40%",
            headerClassName: "k-text-center",
            cell: (props) => (
              <td className={`selectRoleDropdownContainer ${props.dataItem.selected ? 'selected-row-cell' : ''}`}>
                <div className="selectRoleDropdown" style={{ width: "100%" }}>
                  <DropDownList
                    data={this.props.isTenent ? options1 : props.dataItem.isRiskAdmin === false ? options3 : options2}
                    textField="label"
                    dataItemKey="value"
                    value={props.dataItem.selected ? (props.dataItem.role || { label: "Select Role", value: null }) : undefined}
                    disabled={!props.dataItem.selected || !props.dataItem.isVisible}
                    onChange={(e) => this.handleDropDownChangeForRisk(e.target.value, props)}
                    placeholder="Select Role"
                    defaultItem={{ label: "Select Role", value: null }}
                    style={{ width: "100%" }}
                  />
                </div>
              </td>
            ),
          }
        ]}
      />
    );
  }
  }
}
